
export const FindCurrentEmployer = (data:any) => {
    const currentemp = data.filter((item)=> item.currently_employed === true)
    return currentemp[0]
};
